module.exports = __webpack_public_path__ + "img/kslogo.fff9df6a.png";